import React, { useState, useMemo, useEffect } from 'react';

const DIAL_KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];

function PhoneIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="16" height="16">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.62 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6 6l.77-.77a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 17z" />
    </svg>
  );
}

function PhoneOffIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="16" height="16">
      <path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1-1a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 17.72V20.7a2 2 0 0 1-2.18 2 19.5 19.5 0 0 1-8.5-3 19.79 19.79 0 0 1-6-6 19.5 19.5 0 0 1-3-8.5A2 2 0 0 1 4.3 3.18h3a2 2 0 0 1 2 1.72c.129.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11z" />
      <line x1="23" y1="1" x2="1" y2="23" />
    </svg>
  );
}

// Simulated dialer widget — visual only, not wired to a real calling backend.
export function Dialer() {
  const [number, setNumber] = useState('+1 (415) 555-0182');

  return (
    <div className="sp-card">
      <div className="sp-card-head">
        <span className="sp-kicker">Softphone</span>
        <span className="sp-live"><span className="sp-live-dot" />Live</span>
      </div>

      <div className="sp-incoming">
        <div className="sp-incoming-info">
          <span className="sp-incoming-label">INCOMING</span>
          <span className="sp-incoming-name">Sofia Ortega</span>
          <span className="sp-incoming-phone">+1 (555) 318-9912</span>
        </div>
        <div className="sp-incoming-actions">
          <button type="button" className="sp-answer" aria-label="Answer call">
            <PhoneIcon />
          </button>
          <button type="button" className="sp-decline" aria-label="Decline call">
            <PhoneOffIcon />
          </button>
        </div>
      </div>

      <div className="sp-display">{number}</div>

      <div className="sp-dialpad">
        {DIAL_KEYS.map((d) => (
          <button
            key={d}
            type="button"
            className="sp-key"
            onClick={() => setNumber((n) => n + d)}
          >
            {d}
          </button>
        ))}
      </div>

      <button type="button" className="sp-callbtn">
        <PhoneIcon /> Call
      </button>
    </div>
  );
}

// Simulated live-call audio visualizer — animated for show, not bound to real audio.
export function CallWaveform() {
  const bars = useMemo(
    () =>
      Array.from({ length: 40 }, () => ({
        base: 12 + Math.random() * 14,
        delay: (Math.random() * 1.2).toFixed(2),
        dur: (0.55 + Math.random() * 0.7).toFixed(2),
      })),
    []
  );

  const [sec, setSec] = useState(167);
  useEffect(() => {
    const t = setInterval(() => setSec((s) => s + 1), 1000);
    return () => clearInterval(t);
  }, []);
  const mm = String(Math.floor(sec / 60)).padStart(2, '0');
  const ss = String(sec % 60).padStart(2, '0');

  return (
    <div className="wf-card">
      <div className="wf-card-head">
        <span className="sp-kicker">Live Signal</span>
        <span className="wf-timer">{mm}:{ss}</span>
      </div>
      <div className="wf-caller">
        <span className="sp-live"><span className="sp-live-dot" />On Call</span>
        <span className="wf-caller-name">Margaret Chen, +1 (555) 412-7733</span>
      </div>
      <div className="wf-bars" aria-hidden="true">
        {bars.map((b, i) => (
          <span
            key={i}
            className="wf-bar"
            style={{
              '--wf-base': `${b.base}%`,
              animationDelay: `${b.delay}s`,
              animationDuration: `${b.dur}s`,
            }}
          />
        ))}
      </div>
      <p className="wf-footnote">Simulated preview. Not connected to a live call.</p>
    </div>
  );
}
